import React, { useState, useEffect } from "react";

//MUI
import { TablePagination } from "@material-ui/core";

//react-router-dom
import { Link } from "react-router-dom";

//rect-redux
import { connect, useSelector } from "react-redux";

//image
import Male from "../../assets/images/male.png";

//action
import {
  getReportedMoments,
  dismissReport,
  deletePost,
} from "../../store/reportedMoment/action";

//alert
import { warningv2, alert, permissionError } from "../../util/Alert";

//dayjs
import dayjs from "dayjs";
import $ from "jquery";
import { baseURL } from "../../util/Config";

//pagination
const TablePaginationActions = React.lazy(() => import("./TablePagination"));

const ReportedMoments = (props) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const hasPermission = useSelector((state) => state.admin.admin.flag);
  const report = useSelector((state) => state.reportedMoment.reportedMoments);

  useEffect(() => {
    props.getReportedMoments(); //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setData(report);
    console.log("Reported posts:=========", report);
  }, [report]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDismissReport = (postData) => {
    console.log(postData.report);
    const data = warningv2(
      "DISMISS REPORT",
      "Are you sure you want to dismiss this report?",
    );
    data
      .then(async (confirmed) => {
        if (confirmed) {
          if (!hasPermission) return permissionError();
          const succeeded = await props.dismissReport(
            postData?._id?._id,
            postData?.report?.[0]?.postType,
          );
          if (succeeded) alert("Dismissed!", "Report has been dismissed!", "success");
        }
      })
      .catch((error) => console.log(error));
  };

  const handleDeletePost = (postData) => {
    const data = warningv2(
      "DELETE POST",
      "Are you sure you want to delete the reported post?",
    );
    data
      .then(async (confirmed) => {
        if (confirmed) {
          if (!hasPermission) return permissionError();
          const succeeded = await props.deletePost(
            postData?._id?._id,
            postData?.report?.[0]?.postType,
          );
          if (succeeded) alert("Deleted!", "Reported post has been deleted!", "success");
        }
      })
      .catch((error) => console.log(error));
  };

  // set default image

  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", `${baseURL}storage/male.png`);
    });
  });

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Reported Moments</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Reported Moments
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-body card-overflow">
              <table className="table" style={{ borderCollapse: "collapse" }}>
                <thead className="text-center">
                  <tr>
                    <th>No</th>
                    <th>Image</th>
                    <th>Caption</th>
                    <th>Post Id</th>
                    <th>Report Count</th>
                    <th>Info</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {data.length > 0 ? (
                    (rowsPerPage > 0
                      ? data.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                      : data
                    ).map((data, index) => {
                      return (
                        <>
                          <tr>
                            <td>{index + 1}</td>
                            <td>
                              <img
                                height="50px"
                                width="50px"
                                alt="app"
                                className="mx-auto"
                                src={data._id?.post ? data._id.post : Male}
                                style={{
                                  boxShadow:
                                    "0 5px 15px 0 rgb(105 103 103 / 0%)",
                                  border: "2px solid #fff",
                                  borderRadius: 10,
                                  objectFit: "cover",
                                  display: "block",
                                }}
                                onerror='this.src=,`${baseURL}storage/male.png`"'
                              />
                            </td>
                            <td>{data._id?.caption}</td>
                            <td>{data._id?._id}</td>
                            <td className="text-danger">{data?.count}</td>
                            <td
                              data-toggle="collapse"
                              data-target={`#demo${index}`}
                              className="accordion-toggle pointer-cursor pointer-cursor"
                            >
                              <i className="fas fa-info-circle fa-lg"></i>
                            </td>
                            <td className="pointer-cursor">
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <span
                                  className="text-danger-2"
                                  onClick={() => handleDeletePost(data)}
                                >
                                  Delete Post
                                </span>
                                <span
                                  className="text-danger mt-2"
                                  onClick={() => handleDismissReport(data)}
                                >
                                  Dismiss Report
                                </span>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="8" className="hiddenRow">
                              <div
                                id={`demo${index}`}
                                className="accordian-body collapse"
                              >
                                <h6 className="text-danger">Report Details</h6>
                                <table className="w-100">
                                  <thead>
                                    <tr>
                                      <th>No</th>
                                      <th>Image</th>
                                      <th>Name</th>
                                      <th>Unique Id</th>
                                      <th>Country</th>
                                      <th>Description</th>
                                      <th>Reported on</th>
                                    </tr>
                                  </thead>
                                  <tbody
                                    style={{
                                      maxHeight: 100,
                                      overflowY: "auto",
                                    }}
                                  >
                                    {data.report.length > 0 ? (
                                      data.report.map((report, no) => {
                                        return (
                                          <tr key={no}>
                                            <td>{no + 1}</td>
                                            <td>
                                              <img
                                                height="35px"
                                                width="35px"
                                                alt="app"
                                                src={
                                                  report?.fromUser?.image
                                                    ? report?.fromUser.image
                                                    : Male
                                                }
                                                style={{
                                                  boxShadow:
                                                    "0 5px 15px 0 rgb(105 103 103 / 0%)",
                                                  border: "2px solid #fff",
                                                  borderRadius: 10,

                                                  objectFit: "cover",
                                                }}
                                              />
                                            </td>
                                            <td>{report?.fromUser?.name}</td>
                                            <td>
                                              {report?.fromUser?.uniqueId}
                                            </td>
                                            <td className="text-info">
                                              {report?.fromUser?.country
                                                ? report.fromUser?.country
                                                : "-"}
                                            </td>
                                            <td>{report?.description}</td>

                                            <td>
                                              {dayjs(report?.createdAt).format(
                                                "DD MMM, YYYY",
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td colSpan="7" align="center">
                                          Nothing to show!!
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="7" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <TablePagination
        id="pagination"
        component="div"
        rowsPerPageOptions={[5, 10, 25, 100, { label: "All", value: -1 }]}
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          inputProps: { "aria-label": "rows per page" },
          native: true,
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
      />
    </>
  );
};

export default connect(null, { getReportedMoments, dismissReport, deletePost })(
  ReportedMoments,
);
